const PROP_NAME = "data-tuvis-id";
const ROOT_ID = "root_0dd8c26bf0b5";
const MAIN_CONTAINER_ID = "main_54ebfb2e20f4";
const CHAT_CONTAINER_ID = "chats_14e8b3fa154f";
const MESSAGES_LIST_ID = "messages_2bdb47037d32";
const MESSAGE_CONTAINER_ID = "msg_9092ffd4e96b";
const MESSAGE_IN_ID = "msg_in_2fec775b0db6";
const MESSAGE_OUT_ID = "msg_out_8bd471112f96";
const LAST_MESSAGE_ID = "latest_msg_bbb55b4b5234";
const CHAT_CARD_ID = "chat_dbef13ea8387";
const MESSAGE_BODY_ID = "message_body_bsdv42rs8387";

export const SELECTORS = {
  ROOT: { [PROP_NAME]: ROOT_ID },
  CHAT_CONTAINER: { [PROP_NAME]: CHAT_CONTAINER_ID },
  MESSAGE_CONTAINER: { [PROP_NAME]: MESSAGE_CONTAINER_ID },
  MESSAGES_LIST: { [PROP_NAME]: MESSAGES_LIST_ID },
  MESSAGE_ID_PROP: PROP_NAME,
  MESSAGE_IN: { [PROP_NAME]: MESSAGE_IN_ID },
  MESSAGE_OUT: { [PROP_NAME]: MESSAGE_OUT_ID },
  MAIN_CONTAINER: { [PROP_NAME]: MAIN_CONTAINER_ID },
  LAST_MESSAGE: { [PROP_NAME]: LAST_MESSAGE_ID },
  CHAT_CARD_ID: { [PROP_NAME]: CHAT_CARD_ID },
  SELECTED_CHAT: { "data-tuvis-selected": true },
  MESSAGE_BODY: { [PROP_NAME]: MESSAGE_BODY_ID },
  css: {
    app: `[${PROP_NAME}="${ROOT_ID}"]`,
    main: `[${PROP_NAME}="${CHAT_CONTAINER_ID}"]`,
    messageContainer: `[${PROP_NAME}="${MESSAGE_CONTAINER_ID}"]`,
    messagesContainer: `[${PROP_NAME}="${MESSAGES_LIST_ID}"]`,
    anchorTopLevelHref: `[data-testid="element-text"]`,
  },
  domListener: {
    threadElementSelector: PROP_NAME,
  },
};
